import React from "react";
import { LoadingWrapper, Spinner } from "./Styled";

export const Loader = () => {
  return (
    <LoadingWrapper>
      <h2>Loading...</h2>
      <Spinner />
    </LoadingWrapper>
  );
};
